export class Utils {

    static isNullOrEmpty(val) {
        return ( val === ''
            || val === 0
            || val === '0'
            || val === null
        )
    }
}
